<h1 mat-dialog-title>{{data.title}}</h1>
<div mat-dialog-content>
  <p>{{data.text}}</p>
</div>
<div mat-dialog-actions>
  <button mat-raised-button color="accent" (click)="onNoClick()" cdkFocusInitial>No</button>
  <button mat-raised-button color="accent" [mat-dialog-close]="true">Yes</button>
</div>